/* global KMScript */

import ADs from "./ADs";


jQuery(document).ready(function() {
	//Responsive Ads
	if (jQuery('.post-content').length && jQuery(window).width() < 979) {
		let content = jQuery('.post-content .editable-content');
		if ( ! content.length ) {
			content = jQuery('.post-content');
		}

		var postLength = content.find('> p').size(),
			pos1 = Math.round(postLength/3),
			pos2 = pos1*2,
			ad1= jQuery('#aside .cta.side-ad-1').html(),
			ad2= jQuery('#aside .cta.side-ad-2').html();

		jQuery('.post-content p:eq('+pos1+')').after('<div class="post-content-ad">'+ad1+'</div>');
		jQuery('.post-content p:eq('+pos2+')').after('<div class="post-content-ad">'+ad2+'</div>');

		jQuery('#aside .cta.side-ad').each(function() {
			jQuery(this).remove();
		});

	}

	if (jQuery('body').hasClass('archive') && jQuery(window).width() < 979) {

		jQuery('#aside .cta.side-ad').each(function() {
			jQuery(this).remove();
		});

	}

	//Get Theme Path
	var themePath = jQuery('body').attr('data-theme-path');

	//Placeholders
	jQuery('.content-form .text, .content-form .textarea, .content-form .email, .content-form .tel, .content-form .date, .content-form .password').each(function() {
		var labelText = jQuery(this).find('label').text();
		jQuery(this).find('input[type!="hidden"], textarea').attr('placeholder', labelText);
	});

	//Custom Select
	if (jQuery('.content-form .select select').length) {
		jQuery('.content-form .select select').customSelect();
	}

	//Navigation
	jQuery('#header .nav-toggle').click(function(){
		jQuery('body').toggleClass('side-nav-active');
		return false;
	});

	jQuery('#main-nav .menu > li > a').each(function() {

		var navItem = jQuery(this);
		var navItemParent = jQuery(this).parent();

		navItem.wrap('<div class="item" />');

		if (navItemParent.hasClass('menu-item-has-children')) {

			navItemParent.append('<button class="more">More</button>');

			navItemParent.find('.more').click(function() {

				var navItem = jQuery(this),
					navItemParent = navItem.parentsUntil('.menu'),
					navItemMenu = navItemParent.find('.sub-menu');

				jQuery('.main-nav .more').not(navItem).removeClass('active');
				jQuery('.main-nav .sub-menu').not(navItemMenu).removeClass('active').slideUp();

				if (navItem.hasClass('active')) {
					navItem.removeClass('active');
					navItemMenu.removeClass('active').slideUp();
				}
				else {
					navItem.addClass('active');
					navItemMenu.addClass('active').slideDown();
				}

			});

		}

	});

	//Posts Filter
	jQuery('.filter-form select').change(function() {
		window.location = jQuery(this).val();
	});

	//Reviews Filter
	jQuery('#aside .facetwp header button').click(function(){
		jQuery(this).toggleClass('active');
		jQuery(this).closest('.cta').find('.filters').slideToggle();
		return false;
	});

	//Animated Scrolling
	jQuery('.scroll').click(function(){
		var scrollToEl = jQuery(this).attr('href');
		jQuery('html, body').animate({
			scrollTop: jQuery(scrollToEl).offset().top - 100
		}, 1000);
		return false;
	});

	//Remove empty content
	jQuery('p').each(function() {
	    var emptyP = jQuery(this);
	    if(emptyP.html().replace(/\s|&nbsp;/g, '').length == 0)
	    emptyP.remove();
	});

	//Content Tables
    jQuery('.editable-content table').each(function() {
        jQuery(this).wrap('<div class="table-wrap"></div>');
    });

	//Content Iframes
    jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
        var url = jQuery(this).attr('src');
        jQuery(this).attr('src',url+'?rel=0').width('100%').height('100%').wrap('<div class="video-wrap"><div class="video"></div></div>');
    });

    jQuery('iframe[src*="https://www.google.com/maps/"]').each(function() {
        jQuery(this).width('100%').height('100%').wrap('<div class="map-wrap"></div>');
    });

	//Video Popup
	if (jQuery.fn.magnificPopup) {
		jQuery('.video-link').magnificPopup({
			disableOn: 0,
			type: 'iframe',
			mainClass: 'mfp-fade',
			removalDelay: 160,
			preloader: false,
			fixedContentPos: false
		});

		//Gallery Popup
		jQuery('.gallery-list li a, .gallery .gallery-item a').magnificPopup({
			type:'image',
			gallery:{
				enabled:true
			}
		});

		//Premium Popup
		jQuery('.button.login-form').magnificPopup({
			type:'inline',
			midClick: true
		});

		//Newsletter Popup
		jQuery('.button.newsletter').magnificPopup({
			midClick: true,
			items: {
				src: '#newsletter-form',
				type: 'inline'
			}
		});
	}

	//Trending
	if (jQuery.fn.slick && jQuery('#trending-posts .posts ul li:nth-child(2)').length) {

		jQuery('#trending-posts .posts ul').slick({
			autoplay: true,
			autoplaySpeed: 5000,
			speed: 1000,
			arrows: false,
			fade: true,
			pauseOnHover: true,
			dots: false,
		});

	}

	//Slides
	if (jQuery.fn.slick) {
		jQuery('#content .cta-posts').each(function() {

			var slides = jQuery(this);

			if (slides.find('.posts-list li:nth-child(2)').length) {

				slides.append('<div class="controls" />');
				slides.find('.posts-list').slick({
					autoplay: true,
					autoplaySpeed: 5000,
					speed: 1000,
					arrows: false,
					fade: true,
					pauseOnHover: true,
					dots: false,
					arrows: true,
					prevArrow: '<button class="control prev">Previous</button>',
					nextArrow: '<button class="control next">Next</button>',
					appendArrows: slides.find('.controls')
				});

			}

		});
	}

	//Accordions
	jQuery('.info-list').each(function() {

		var listEl = jQuery(this);

		listEl.find('li:first .toggle').addClass('active');
		listEl.find('li:not(:first) .info').hide();

		listEl.find('.toggle').each(function() {

			jQuery(this).click(function(){

				var infoToggle = jQuery(this),
					infoWrap = infoToggle.attr('href');

				if (infoToggle.hasClass('active')) {

					infoToggle.removeClass('active');
					listEl.find(infoWrap).slideUp();

				}
				else {

					listEl.find('li .toggle').each(function() {
						jQuery(this).removeClass('active');
					});
					infoToggle.addClass('active');

					listEl.find('li .info').each(function() {
						jQuery(this).slideUp();
					});
					listEl.find(infoWrap).slideDown();

				}

				return false;

			});

		});

	});

	//FacetWP Pagination
	jQuery(document).on('facetwp-loaded', function() {
        if (FWP.loaded) {
            jQuery('html, body').animate({
                scrollTop: jQuery('body').offset().top
            }, 0);
        }
    });

});

//Scroll Events
jQuery(window).load(function() {

	 setTimeout(function() {

		var controller = new ScrollMagic.Controller();

		//Header
		var headerOffset = 130;
		if (jQuery('body').hasClass('logged-in')) {
			var headerOffset = 98;
		}

		new ScrollMagic.Scene({
			    triggerElement:'#header',
			    triggerHook: 0,
			})
			.setClassToggle('body', 'nav-active')
			.offset(headerOffset)
			.addTo(controller);

		var adOffset = -30;
		if (jQuery('body').hasClass('logged-in')) {
			var adOffset = -52;
		}

		//Header Ad
		if (jQuery('#content .header-ad iframe').length) {

			var headerAdHeight = jQuery('#content .header-ad iframe').outerHeight();

			if (headerAdHeight == 90) {

				jQuery('#content .header-ad').addClass('sml');

				new ScrollMagic.Scene({
					    triggerElement: '#content .header-ad',
					    triggerHook: 0,
					    duration: 80
					})
					.setClassToggle('#content .header-ad', 'active')
					.offset(adOffset + 80)
					.addTo(controller);

				new ScrollMagic.Scene({
					    triggerElement: '#content .header-ad',
					    triggerHook: 0,
					    duration: 90
					})
					.setClassToggle('#content .header-ad', 'sticky')
					.offset(adOffset + 160)
					.addTo(controller);

			}

		}

		//Side Ad 1
		if (jQuery('#aside .side-ad-1 iframe').length) {

			var sideAd1Height = jQuery('#aside .side-ad-1 iframe').outerHeight();

			if (sideAd1Height == 250) {

				new ScrollMagic.Scene({
					    triggerElement: '#aside .side-ad-1',
					    triggerHook: 0,
					    duration: 350
					})
					.setClassToggle('#aside .side-ad-1 .ad', 'active')
					.offset(adOffset)
					.addTo(controller);

				new ScrollMagic.Scene({
					    triggerElement: '#aside .side-ad-1',
					    triggerHook: 0,
					})
					.setClassToggle('#aside .side-ad-1 .ad', 'sticky')
					.offset(adOffset + 350)
					.addTo(controller);

			}

		}

		//Side Ad 2
		if (jQuery('#aside .side-ad-2 iframe').length) {

			const sidebarHeight = jQuery('#aside').outerHeight();
			const ctasHeight = jQuery('#aside .ctas').outerHeight();
			const sideAd2Height = jQuery('#aside .side-ad-2 iframe').outerHeight();
			const postHeight = jQuery('#main').outerHeight();

			if (ctasHeight < postHeight) {

				const sideAdDuration = (sidebarHeight - ctasHeight) - 20;
				const heightDiff = (postHeight - ctasHeight) -20;

				new ScrollMagic.Scene({
					    triggerElement: '#aside .side-ad-2',
					    triggerHook: 0,
					    duration: sideAdDuration
					})
					.setClassToggle('#aside .side-ad-2 .ad', 'active')
					.offset(adOffset)
					.addTo(controller);

				new ScrollMagic.Scene({
					    triggerElement: '#aside .side-ad-2',
					    triggerHook: 0,
					})
					.setClassToggle('#aside .side-ad-2 .ad', 'sticky')
					.offset(adOffset + heightDiff)
					.addTo(controller);

			}

		}

		//Site Ad
		if (jQuery('#content .site-ad iframe').length) {

			var contentHeight = jQuery('#content').outerHeight(),
				siteAdHeight = jQuery('#content .site-ad').outerHeight();

			if (siteAdHeight < contentHeight) {

				var siteAdDuration = (contentHeight - siteAdHeight);

				new ScrollMagic.Scene({
					    triggerElement: '#content',
					    triggerHook: 0,
					    duration: siteAdDuration
					})
					.setClassToggle('#content .site-ad ', 'active')
					.offset(adOffset + 50)
					.addTo(controller);

				new ScrollMagic.Scene({
					    triggerElement: '#content',
					    triggerHook: 0,
					})
					.setClassToggle('#content .site-ad', 'sticky')
					.offset(siteAdDuration)
					.addTo(controller);

			}

		}

	 }, 2000);

	 //Tabbed Content
	jQuery('.tabs-wrap').each(function() {

		var tabsEl = jQuery(this);

		tabsEl.find('.tabs .tab').hide();
		tabsEl.find('.tabs .tab:first').show();
		tabsEl.find('.tabs-list li:first').addClass('selected');

		tabsEl.find('.tabs-list li a').click(function(){
			currentTab = jQuery(this).attr('href');
			updateTabs();
			return false;
		});

		if (tabsEl.find('.select-tabs').length) {
			tabsEl.find('.select-tabs select option:first').attr('selected', true);
			tabsEl.find('.select-tabs select').change(function() {
				currentTab = jQuery(this).val();
				updateTabs();
			});
		}

		function updateTabs() {

			tabsEl.find('.tabs-list li').removeClass('selected');
			tabsEl.find('a[href="'+currentTab+'"]').parent().addClass('selected');

			if (tabsEl.find('.select-tabs').length) {
				tabsEl.find('.select-tabs select option:first').attr('selected', false);
				tabsEl.find('.select-tabs select option[value="'+currentTab+'"]').attr('selected', true);
				jQuery('.select-tabs select').trigger('render');
			}

			tabsEl.find('.tabs .tab').hide();
			jQuery(currentTab).show();

		}

	});

});

/*!
 * jquery.customSelect() - v0.5.1
 * http://adam.co/lab/jquery/customselect/
 * 2014-04-19
 *
 * Copyright 2013 Adam Coulombe
 * @license http://www.opensource.org/licenses/mit-license.html MIT License
 * @license http://www.gnu.org/licenses/gpl.html GPL2 License
 */
(function(a) {
	a.fn.extend({
			customSelect: function(c) {
					if (typeof document.body.style.maxHeight === "undefined") {
							return this
					}
					var e = {
									customClass: "customSelect",
									mapClass: true,
									mapStyle: true
							},
							c = a.extend(e, c),
							d = c.customClass,
							f = function(h, k) {
									var g = h.find(":selected"),
											j = k.children(":first"),
											i = g.html() || "&nbsp;";
									j.html(i);
									if (g.attr("disabled")) {
											k.addClass(b("DisabledOption"))
									} else {
											k.removeClass(b("DisabledOption"))
									}
									setTimeout(function() {
											k.removeClass(b("Open"));
											a(document)
													.off("mouseup.customSelect")
									}, 60)
							},
							b = function(g) {
									return d + g
							};
					return this.each(function() {
							var g = a(this),
									i = a("<span />")
									.addClass(b("Inner")),
									h = a("<span />");
							g.after(h.append(i));
							h.addClass(d);
							if (c.mapClass) {
									h.addClass(g.attr("class"))
							}
							if (c.mapStyle) {
									h.attr("style", g.attr("style"))
							}
							g.addClass("hasCustomSelect")
									.on("render.customSelect", function() {
											f(g, h);
											g.css("width", "");
											var k = parseInt(g.outerWidth(), 10) - (parseInt(h.outerWidth(), 10) - parseInt(h.width(), 10));
											h.css({
													display: "inline-block"
											});
											var j = h.outerHeight();
											if (g.attr("disabled")) {
													h.addClass(b("Disabled"))
											} else {
													h.removeClass(b("Disabled"))
											}
											i.css({
													width: k,
													display: "inline-block"
											});
											g.css({
													"-webkit-appearance": "menulist-button",
													width: h.outerWidth(),
													position: "absolute",
													opacity: 0,
													height: j,
													fontSize: h.css("font-size")
											})
									})
									.on("change.customSelect", function() {
											h.addClass(b("Changed"));
											f(g, h)
									})
									.on("keyup.customSelect", function(j) {
											if (!h.hasClass(b("Open"))) {
													g.trigger("blur.customSelect");
													g.trigger("focus.customSelect")
											} else {
													if (j.which == 13 || j.which == 27) {
															f(g, h)
													}
											}
									})
									.on("mousedown.customSelect", function() {
											h.removeClass(b("Changed"))
									})
									.on("mouseup.customSelect", function(j) {
											if (!h.hasClass(b("Open"))) {
													if (a("." + b("Open"))
															.not(h)
															.length > 0 && typeof InstallTrigger !== "undefined") {
															g.trigger("focus.customSelect")
													} else {
															h.addClass(b("Open"));
															j.stopPropagation();
															a(document)
																	.one("mouseup.customSelect", function(k) {
																			if (k.target != g.get(0) && a.inArray(k.target, g.find("*")
																					.get()) < 0) {
																					g.trigger("blur.customSelect")
																			} else {
																					f(g, h)
																			}
																	})
													}
											}
									})
									.on("focus.customSelect", function() {
											h.removeClass(b("Changed"))
													.addClass(b("Focus"))
									})
									.on("blur.customSelect", function() {
											h.removeClass(b("Focus") + " " + b("Open"))
									})
									.on("mouseenter.customSelect", function() {
											h.addClass(b("Hover"))
									})
									.on("mouseleave.customSelect", function() {
											h.removeClass(b("Hover"))
									})
									.trigger("render.customSelect")
					})
			}
	})
})(jQuery);

(function() {
	document.addEventListener( 'DOMContentLoaded', () => {
		ADs.init();
	} );
})();
